module.exports = __webpack_public_path__ + "img/guide-08.5fbd94c1.jpg";